module.exports = require('./react-vr-player');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-vr-player/index.js
 ** module id = 159
 ** module chunks = 0
 **/